import { forEach } from 'lodash';
import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { exportReportAsFile } from '../../../utils/report';
import { reportTypes } from '../../../utils/filters';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const transformReportGuidanceTypes: Record<string, string> = {
    whitelists: 'whitelist',
    blacklists: 'blacklist'
};

const transformWords = (words: any[]) => {
    const transformedWords: any[] = [];
    forEach(words, word => {
        transformedWords.push({
            ...word,
            keywords: words
        });
    });
    return transformedWords;
};

const transformSets = (sets: any[] | null) => {
    const tranformedSets: any[] = [];
    (sets ?? []).forEach(set => {
        tranformedSets.push({ ...set, phraseGroups: [{ ...set, keywords: set.words ?? [] }] });
    });
    return tranformedSets;
};

const transformReportType = (rTypes: any, type: string) => {
    return {
        percent: rTypes.percent,
        sets: transformSets(rTypes.wordgroups)
    };
};

const transformResultData = (reportData: any) => {
    const transformedReportData: any = {};
    forEach(transformReportGuidanceTypes, (type, key) => {
        const reportType = reportData[type];
        transformedReportData[key] = transformReportType(reportType, type);
    });
    return { ratedCalls: reportData.ratedCalls, ...transformedReportData };
};

const transformResultsForRollback = (results: any[]) => {
    return results.map(result => {
        return {
            ...result,
            report: result.report.map((r: any) => {
                return { date: r.date, reportData: transformResultData(r.report) };
            })
        };
    });
};

export const reportRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_REPORT]: params => ({
        transformResponse: res => {
            const results = res?.report?.data;

            const transformedResults =
                params.reportType === reportTypes.keywordGuidance ? transformResultsForRollback(results) : results;

            return {
                entities: {
                    [ENTITY_NAMES.REPORT]: {
                        type: params.reportType,
                        data: transformedResults
                    }
                }
            };
        },
        descriptors: {
            [ENTITY_NAMES.REPORT]: {
                method: 'post',
                url: DASHBOARD_API_URLS.V2.REPORT,
                defaultEndpoint: ENDPOINTS.BASE_URL,
                data: {
                    ...params,
                    reportType: params.reportType
                }
            }
        }
    }),
    [REQUEST_TYPES.EXPORT_REPORT]: params => ({
        transformResponse: res => {
            const contentDisposition = res?.report?.headers?.['content-disposition'];
            const fileContent = res?.report?.data;
            exportReportAsFile(fileContent, contentDisposition);

            return {};
        },
        descriptors: {
            [ENTITY_NAMES.REPORT]: {
                method: 'post',
                url: DASHBOARD_API_URLS.V2.REPORT_CSV,
                defaultEndpoint: ENDPOINTS.BASE_URL,
                data: params
            }
        }
    })
};
